import React from "react";
import TagField from "../Fields/TagField";

export default function SetTagsAction(props) {
    return (
        <TagField
            name={`actions[${props.index}].properties.tags`}
            label="Tags"
        />
    );
}
